import React from 'react';
import classNames from 'classnames';
import { isBlank } from 'helpers/string_helpers';

type Props = {
  children?: React.ReactNode,
  imageUrl?: string,
  subtitle?: string,
  title: string,
  whiteTitle: boolean,
};

export default function TitleBar({ children, imageUrl, subtitle, title, whiteTitle }: Props) {
  const headerClass = classNames({
    'page-header': true,
    'with-image': !isBlank(imageUrl),
    'white': whiteTitle,
  });

  const titleClass = classNames({
    'h2': true,
    'with-border': !isBlank(subtitle),
  });

  return (
    <div className={headerClass}>
      <div className="container">
        <div className="title-bar">
          <div>
            {!isBlank(imageUrl) && (
              <img className="visible-lg-inline visible-md-inline" src={imageUrl} />
            )}
          </div>
          <span className={titleClass}>
            {title}
          </span>
          {!isBlank(subtitle) && (
            <h4 className="visible-lg-inline visible-md-inline">
              {subtitle}
            </h4>
          )}
          {children && (
            <div className="pull-right">
              {children}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
